












































// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';

const cssPrefix = 'dropdown-main-unit';

@Component
export default class SwDropdownUnit extends SwExtendedVue {
  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  highlight: boolean;

  cssPrefix = cssPrefix;
}
